export default {
  logo: '후오비',
  nav: [
    {
      cur: '거래소',
      href: '/exchange',
      sub: [
        {
          cur: '일반 모드',
          href: '/exchange',
        },
        {
          cur: '전문가 모드',
          href: '/expert',
        },
      ]
    },
    {
      cur: 'C2C 마켓',
      href: '/c2c',
      target: '_blank',
    },
    {
      cur: '고객 지원',
      href: '/support',
      sub: [
        {
          cur: '공지사항',
          href: '/home',
        },
        {
          cur: '이용안내',
          href: '/home',
        },
        {
          cur: '수수료 안내',
          href: '/home',
        },
        {
          cur: '코인 소개',
          href: '/home',
        },
        {
          cur: '거래 가이드',
          href: '/home',
        },
        {
          cur: 'API 문서',
          href: '/home',
        },
      ]
    },
  ],
  signup: [
    {
      cur: '로그인',
      href: '/login',
    },
    {
      cur: '회원가입',
      href: '/signup',
    },
  ],
  user: [
    {
      cur: '로그아웃',
      href: '/logout',
    },
    {
      cur: '마이페이지',
      href: '/mypage',
    },
  ],
  sitemap: [
    {
      cur: '이용안내',
      sub: [
        {
          cur: '공지사항',
          href: '/home',
        },
        {
          cur: '이용안내',
          href: '/home',
        },
        {
          cur: '수수료 안내',
          href: '/home',
        },
        {
          cur: '코인 소개',
          href: '/home',
        },
        {
          cur: '거래 가이드',
          href: '/home',
        },
      ]
    },
    {
      cur: 'Huobi',
      sub: [
        {
          cur: 'Huobi 소개',
          href: '/home',
        },
        {
          cur: '채용안내',
          href: '/home',
        },
        {
          cur: '후오비 엘리트',
          href: '/home',
        },
        {
          cur: 'API 문서',
          href: '/home',
        },
      ]
    },
    {
      cur: '약관안내',
      sub: [
        {
          cur: '이용약관',
          href: '/home',
        },
        {
          cur: '개인정보처리방침',
          href: '/home',
        },
        {
          cur: '사업자정보확인',
          href: '/home',
        },
      ]
    },
  ],
  snsNav: {
    cur: '공식채널',
    list: [
      {
        id: 'kakao',
        cur: '카카오톡',
        href: 'kakao',
      },
      {
        id: 'facebook',
        cur: '페이스북',
        href: 'kakao',
      },
      {
        id: 'twitter',
        cur: '트위터',
        href: 'kakao',
      },
      {
        id: 'telegram',
        cur: '텔레그램',
        href: 'kakao',
      },
    ]
  },
  address: '후오비주식회사 / 대표 박시덕 / 서울특별시 강남구 테헤란로 316<br/>메트라이프 타워 1층/2층 (역삼동 707-5) 사업자등록번호 420-87-008832018',
  copyright: '2018 Huobi korea. All rights reserved. <br/>The leading global digital asset exchange.',
};


// WEBPACK FOOTER //
// ./src/locales/zh-CN/common.ts